var _rect, _rect2, _rect3, _rect4, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDriverBehaviour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.26699,
    y: 0.800195,
    width: 70,
    height: 70,
    rx: 35,
    stroke: "url(#paint0_linear_706_71250)",
    strokeWidth: 1.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.26699,
    y: 0.800195,
    width: 70,
    height: 70,
    rx: 35,
    stroke: "url(#paint1_linear_706_71250)",
    strokeWidth: 1.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.8666,
    y: 10.3998,
    width: 50.8,
    height: 50.8,
    rx: 25.4,
    stroke: "url(#paint2_linear_706_71250)",
    strokeWidth: 1.2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10.8666,
    y: 10.3998,
    width: 50.8,
    height: 50.8,
    rx: 25.4,
    stroke: "url(#paint3_linear_706_71250)",
    strokeWidth: 1.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_706_71250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.1873 38.3805C39.4666 38.3805 42.1344 35.7126 42.1344 32.4334V28.4258C41.7604 28.5181 41.3696 28.5675 40.9674 28.5675H30.2402V32.4334C30.2402 35.7126 32.9081 38.3805 36.1873 38.3805Z",
    fill: "#009DDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1956 23.6983V21.7998H33.4685C31.6884 21.7998 30.2402 23.2479 30.2402 25.028V26.9265H40.9674C42.7474 26.9265 44.1956 25.4784 44.1956 23.6983Z",
    fill: "#009DDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.207 39.7578V40.4032C34.207 41.4953 35.0956 42.3839 36.1878 42.3839C37.2799 42.3839 38.1685 41.4953 38.1685 40.4032V39.7578C37.5368 39.9288 36.8728 40.0206 36.1878 40.0206C35.5027 40.0206 34.8387 39.9288 34.207 39.7578Z",
    fill: "#009DDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7755 29.6788V32.433C43.7755 32.5124 43.7739 32.5914 43.7715 32.6701H44.1305C44.9553 32.6701 45.6262 31.9992 45.6262 31.1744C45.6262 30.3497 44.9552 29.6787 44.1305 29.6787H43.7755V29.6788Z",
    fill: "#009DDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2447 32.6701H28.6037C28.6013 32.5913 28.5996 32.5123 28.5996 32.433V29.6787H28.2447C27.42 29.6787 26.749 30.3497 26.749 31.1744C26.749 31.9992 27.42 32.6701 28.2447 32.6701Z",
    fill: "#009DDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.502 49.8001H37.9273L47.0178 41.2667V38.6133L34.502 49.8001Z",
    fill: "#009DDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3252 49.7993H46.8602L45.699 44.7549L40.3252 49.7993Z",
    fill: "#009DDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5805 41.6689C39.0661 43.0436 37.7396 44.025 36.1877 44.025C34.6357 44.025 33.3092 43.0436 32.7949 41.6689H28.6727L27.0029 43.3387L25.5156 49.8002H32.0406L41.1378 41.6689H39.5805Z",
    fill: "#009DDD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_706_71250",
    x1: 6.52797,
    y1: 75.3075,
    x2: 75.1231,
    y2: -4.57542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.323723,
    stopColor: "#009DDD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_706_71250",
    x1: 71.6499,
    y1: -8.91687,
    x2: 6.52797,
    y2: 71.4002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576615,
    stopColor: "#009DDD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_706_71250",
    x1: 4.60531,
    y1: 12.7353,
    x2: 62.0569,
    y2: 61.7998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DDD",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.323723,
    stopColor: "#009DDD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_706_71250",
    x1: 72.5408,
    y1: 73.5417,
    x2: 12.1537,
    y2: 30.7675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576615,
    stopColor: "#009DDD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_706_71250"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(22.2666 21.7998)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverBehaviour);
export default __webpack_public_path__ + "static/media/DriverBehaviour.0af097685e892d2783f634ce543d7a26.svg";
export { ForwardRef as ReactComponent };